import _ from 'underscore';
import React from 'react';
import {
  mergeClasses,
} from '@fluentui/react-components';

export const HistoryListImages = (props) => {
  const {
    onClick,
    onKeyDown,
    historyList,
    selectedIndex,
    listStyle,
  } = props;

  return (
    <div className="history-list-images" style={listStyle}>
      {_.map(historyList, ({ imageUrl }, index) => (
        <div
          key={`${index}`}
          className={mergeClasses('history-item-root', index === selectedIndex ? 'selected' : '')}
          onClick={() => onClick(index)}
          role="button"
          tabIndex={0}
          onKeyDown={e => onKeyDown(index, e)}
        >
          <div className="history-item">
            <img src={imageUrl} alt="generation history" />
          </div>
        </div>
      ))}
    </div>
  );
};

